import axios from 'axios'
import { Toast } from 'cube-ui'
import store from '../store/index'
import rx from './rx'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 100000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  // TODO
  config => {
    config.headers['Content-Type'] = 'application/json'
    if (store.state.token.token) {
      config.headers['Authorization'] = 'Bearer ' + store.state.token.token
    }

    if (store.state.token.version) {
      config.headers['Api-Version'] = store.state.token.version
    }

    return config
  }, error => {
    Toast.$create({
      txt: error.message,
      type: 'error'
    }).show()
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('[http] res:', res)
    if (res.code === 402 || res.code === 403) { // 402token 过期  403token 格式错误
      Toast.$create({
        txt: res.msg,
        type: 'error'
      }).show()
      console.log('rx call ')
      rx.call()
      return Promise.reject(new Error('error code:' + res.code))
    } else if (res.code !== 200) {
      Toast.$create({
        txt: res.msg,
        type: 'error'
      }).show()
      return Promise.reject(new Error('error code:' + res.code))
    } else {
      return response.data
    }
  },
  error => {
    Toast.$create({
      txt: error.message,
      type: 'error'
    }).show()
    return Promise.reject(error)
  }
)

export default service
